var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 52,
    fill: "#B8B8B8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    transform: "translate(-1085 -648)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: -1085,
    y: -648,
    width: 1920,
    height: 1057,
    fill: "#040404"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -432,
    y: -415,
    width: 863,
    height: 589,
    rx: 50,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.60956 0.810547H23.6096L38 15.8243V45.0092C38 48.6599 35.0411 51.6187 31.3904 51.6187H6.60956C2.95886 51.6187 0 48.6598 0 45.0092V7.4201C0 3.76947 2.95886 0.810547 6.60956 0.810547Z",
    fill: "#0263D1",
    fillOpacity: 0.85
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.302,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5891 0.810547V15.7009H38.0001L23.5891 0.810547Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.13696 37.0639V28.6529H9.11643C9.7123 28.6529 10.2671 28.742 10.7808 28.9064C11.2945 29.0776 11.7603 29.3241 12.1781 29.653C12.5959 29.9817 12.9247 30.4201 13.1644 30.968C13.4041 31.5159 13.5275 32.1461 13.5275 32.8584C13.5275 33.5707 13.4041 34.2009 13.1644 34.7488C12.9247 35.2967 12.5959 35.7351 12.1781 36.0638C11.7603 36.3926 11.2945 36.6392 10.7808 36.8104C10.2671 36.9748 9.71236 37.0639 9.11643 37.0639H6.13696ZM8.2397 35.2351H8.86298C9.1986 35.2351 9.51367 35.194 9.79447 35.1187C10.0821 35.0365 10.3424 34.9064 10.589 34.7351C10.8355 34.5638 11.0273 34.3173 11.1643 33.9954C11.3081 33.6803 11.3766 33.2967 11.3766 32.8584C11.3766 32.4201 11.3081 32.0365 11.1643 31.7146C11.0273 31.3995 10.8355 31.1529 10.589 30.9817C10.3424 30.8036 10.0821 30.6804 9.79447 30.5981C9.51367 30.5228 9.1986 30.4817 8.86298 30.4817H8.2397V35.2351ZM18.6301 37.1598C17.363 37.1598 16.3151 36.7488 15.4863 35.9338C14.6576 35.1187 14.2466 34.0913 14.2466 32.8585C14.2466 31.6256 14.6576 30.5982 15.4863 29.7832C16.3151 28.9681 17.363 28.5571 18.6301 28.5571C19.8767 28.5571 20.911 28.9681 21.7397 29.7832C22.5616 30.5982 22.9726 31.6256 22.9726 32.8585C22.9726 34.0913 22.5616 35.1187 21.7397 35.9338C20.911 36.7488 19.8767 37.1598 18.6301 37.1598ZM17.0137 34.6324C17.4315 35.0981 17.9657 35.331 18.6164 35.331C19.2671 35.331 19.7945 35.0981 20.2123 34.6324C20.6301 34.1598 20.8356 33.5707 20.8356 32.8584C20.8356 32.1461 20.6301 31.557 20.2123 31.0844C19.7945 30.6187 19.2671 30.3858 18.6164 30.3858C17.9657 30.3858 17.4315 30.6187 17.0137 31.0844C16.5959 31.557 16.3835 32.1461 16.3835 32.8584C16.3835 33.5707 16.5959 34.1598 17.0137 34.6324ZM27.9726 37.1598C26.7466 37.1598 25.726 36.7762 24.9178 36.0228C24.1027 35.2625 23.6987 34.2077 23.6987 32.8584C23.6987 31.5159 24.1097 30.4611 24.9316 29.7009C25.7603 28.9406 26.7672 28.557 27.9727 28.557C29.0617 28.557 29.9521 28.8241 30.6576 29.3652C31.3562 29.8995 31.7604 30.6118 31.8631 31.5022L29.7398 31.9337C29.6507 31.468 29.4384 31.0913 29.1096 30.8104C28.7809 30.5296 28.3973 30.3858 27.9589 30.3858C27.3562 30.3858 26.8562 30.5981 26.452 31.0296C26.0479 31.4679 25.8424 32.0706 25.8424 32.8583C25.8424 33.646 26.0479 34.2488 26.4452 34.6803C26.8493 35.1186 27.3493 35.331 27.9589 35.331C28.3972 35.331 28.774 35.2077 29.0822 34.9611C29.3904 34.7146 29.5822 34.3858 29.6644 33.9748L31.8356 34.468C31.637 35.3173 31.1986 35.9749 30.5137 36.4474C29.8356 36.9201 28.9863 37.1598 27.9726 37.1598Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1057,
    fill: "white",
    transform: "translate(-1085 -648)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocImg);
export default __webpack_public_path__ + "static/media/DOC_Img.8c07264d9b73d4f9e73b7f3a0d09486c.svg";
export { ForwardRef as ReactComponent };